
const convertText = (src) => {
	return src
		.replace(/[^ A-ZÅÆØa-zåæø0-9\x2D]+/g, "")
		.trimEnd()
		.replace(/\s+/g, "-")
		.toLowerCase();
};

export {convertText};